import React from "react";
import AppText from "./AppText";
import CopyButton from "../../presentational/CopyButton";
import Button from "../../presentational/Button";
import { useAuthenticationConfiguration } from "./Configuration";

import "./RecoveryCodes.css";

interface RecoveryCodesProps {
    serverError: string;
    isLoading: boolean;
    recoveryCodes: string[];
    next: () => void;
}

const RecoveryCodes: React.FC<RecoveryCodesProps> = ({ serverError, isLoading, recoveryCodes, next }) => {
    const { isModal } = useAuthenticationConfiguration();
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        next();
        return false;
    };

    return (
        <main className="recovery-codes-page">
            <div className="form-wrapper">
                <form className="form" onSubmit={handleSubmit}>
                    {serverError && <p className="server-error">{serverError}</p>}
                    <div className="form-header">
                        {!isModal && (
                            <img
                                className="form-header-logo"
                                src="https://assets.careevolutionapps.com/CareEvolution/Images/MDHD/mdhd-blue-bug-logo-centered.svg"
                                alt="MyDataHelps Designer Logo"
                            />
                        )}
                        <h2>
                            <AppText textKey="recovery-codes-title" />
                        </h2>
                        <p>
                            <AppText textKey="recovery-codes-info" />
                        </p>
                    </div>
                    <div id="save-recovery-codes" heap-ignore="true">
                        <div id="recovery-codes-grid">
                            {recoveryCodes.map((recoveryCode, i) => (
                                <div key={`recoveryCode${i}`} className="recovery-code">
                                    {recoveryCode}
                                </div>
                            ))}
                        </div>
                        <div id="recovery-codes-text" hidden>
                            {recoveryCodes.join("\n")}
                        </div>
                        <CopyButton
                            className="editor-controls-button primary-button"
                            value={recoveryCodes.join("\n")}
                        ></CopyButton>
                    </div>
                    <Button
                        onClick={handleSubmit}
                        className="editor-controls-button text-button"
                        type="submit"
                        loading={isLoading}
                    >
                        <AppText textKey="recovery-codes-submit-label" />
                    </Button>
                </form>
            </div>
        </main>
    );
};

export default RecoveryCodes;
